/* ============================================================================================
   yk-pdp.js — Refonte fiche produit YAMAKITS (port maquette → thème « SHOP 1 », base Hyper). Chargé en defer par snippets/yk-pdp-head.liquid.
     [1] éclat bleu à particules (#ykFx)            — verbatim maquette (bloc 31, index.html L4083-4116)
     [2] état sélectionné : délégation de clic      — verbatim maquette (bloc 31, index.html L4139-4184)
     [3] galerie mobile + barre d'achat collante    — RÉÉCRITE pour le Swiper du thème (spec §6)
   ============================================================================================ */

/* [1] Éclat bleu à particules au clic */
(function(){
 if(matchMedia('(prefers-reduced-motion:reduce)').matches)return;
 var SEL='.yk-sz-btn,.yk-short-sz,.yk-tab,.yk-badge-card,.ai__sugg button,.ai__form > button,.qr__nav,.ykl-tab,.product-form__submit,.yk-atc,.yk-size-guide-btn,.yk-quiz-opt,.yk-quiz-next,.yk-switch,.button';
 var TONES=['#5271FF','#5271FF','#7C93FF','#3F5DF0','#A8B8FF'];
 var box=null, live=0;
 function fx(){ if(!box){box=document.createElement('div');box.id='ykFx';document.body.appendChild(box)} return box }
 function burst(x,y,big){
  if(live>90)return;
  var f=fx(), n=big?12:4, frag=document.createDocumentFragment();
  var g=document.createElement('u');g.style.cssText='left:'+x+'px;top:'+y+'px';frag.appendChild(g);
  var r=document.createElement('s');r.style.cssText='left:'+x+'px;top:'+y+'px';frag.appendChild(r);
  for(var i=0;i<n;i++){
   var p=document.createElement('b');
   var ang=(-90+(Math.random()*300-150))*Math.PI/180;
   var dist=(big?34:24)+Math.random()*(big?46:30);
   var sz=big?(3+Math.random()*4):(2+Math.random()*3);
   p.style.cssText='left:'+x+'px;top:'+y+'px;width:'+sz.toFixed(1)+'px;height:'+sz.toFixed(1)+'px;'+
    '--a:'+ang.toFixed(3)+'rad;--d:'+dist.toFixed(0)+'px;--t:'+(480+Math.random()*260).toFixed(0)+'ms;'+
    '--g:'+(10+Math.random()*22).toFixed(0)+'px;--c:'+TONES[i%TONES.length];
   frag.appendChild(p);
  }
  live+=n+2; f.appendChild(frag);
  var kids=[g,r];
  f.addEventListener('animationend',function h(e){
   if(e.target.parentNode===f){e.target.remove();live--}
  });
  setTimeout(function(){ [g,r].forEach(function(e){if(e.parentNode)e.remove()}); },700);
 }
 document.addEventListener('pointerdown',function(e){
  var t=e.target.closest(SEL); if(!t)return;
  var big=t.matches('.product-form__submit,.yk-atc,.button');
  burst(e.clientX,e.clientY,big);
 },{passive:true});
})();

/* [2] État sélectionné : délégation de clic, aucun MutationObserver, aucune boucle possible. */
(function(){
 var ON={'border-color':'#5271FF','border-width':'2px','border-style':'solid','background-color':'rgba(82,113,255,.08)','color':'#0B1220','box-shadow':'inset 0 0 0 2px #5271FF, 0 4px 14px -6px rgba(82,113,255,.55)'};
 var PROPS=Object.keys(ON);
 var SEL='.yk-sz-btn,.yk-short-sz,.yk-badge-card,.yk-tab';
 /* grandes cartes d'option : cadre bleu seulement, pas de fond teinté */
 var CARD='.yk-card,.yk-short-card,.yk-vplayer-card';
 var CARD_ON={'border-color':'#5271FF','box-shadow':'0 0 0 1px #5271FF, 0 6px 20px -10px rgba(82,113,255,.45)'};
 var CARD_PROPS=Object.keys(CARD_ON);
 function cardOn(el){CARD_PROPS.forEach(function(p){el.style.setProperty(p,CARD_ON[p],'important')})}
 function cardOff(el){CARD_PROPS.forEach(function(p){el.style.removeProperty(p)})}
 function active(el){return el.classList.contains('on')||el.classList.contains('open')}
 var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;

 function on(el){
  PROPS.forEach(function(p){el.style.setProperty(p,ON[p],'important')});
  el.style.setProperty('position','relative','important');
 }
 function off(el){
  PROPS.forEach(function(p){el.style.removeProperty(p)});
  el.style.removeProperty('position');
  el.classList.remove('yk-act');
 }
 function ring(el){
  if(reduce)return;
  el.classList.remove('yk-act'); void el.offsetWidth; el.classList.add('yk-act');
  clearTimeout(el._t); el._t=setTimeout(function(){el.classList.remove('yk-act')},620);
 }
 function sync(){
  document.querySelectorAll(SEL).forEach(function(el){
   el.classList.contains('on') ? on(el) : off(el);
  });
  document.querySelectorAll(CARD).forEach(function(el){
   active(el) ? cardOn(el) : cardOff(el);
  });
 }
 document.addEventListener('click',function(e){
  var t=e.target.closest&&(e.target.closest(SEL)||e.target.closest(CARD));
  if(!t)return;
  setTimeout(function(){
   sync();
   if(t.classList.contains('on')) ring(t);
  },0);
 },{passive:true});
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sync);
 else sync();
})();

/* [3] Galerie mobile (compteur x/N + pastilles) et barre d'achat collante.
   yk-port (spec §6) : la maquette pilotait un défilement natif (scrollLeft) sur son #Slider-Gallery-main statique ; sur le thème réel,
   snippets/product-media-gallery.liquid rend <media-gallery id="MediaGallery-{{ section.id }}"> / #Slider-Gallery-{{ section.id }} et, pour
   une section de template JSON, section.id vaut « template--<id>__main » (PAS « main » comme l'écrit la spec §4) : les ids réels sont donc
   MediaGallery-template--…__main / Slider-Gallery-template--…__main. On lit cet id sur <product-info data-section="{{ section.id }}">
   (sections/main-product.liquid), ancêtre de #ykmBar, et on scope la piste dans la galerie (le quick-view a sa propre media-gallery).
   media-gallery.js crée un Swiper sur mobile (gallery.sliderInstance.slider, instancié après inView, sous FoxTheme.config.mediaQueryMobile).
   On attend cette instance (poll 100 ms, 5 s), on crée .ykm-count dans .product__media-gallery-viewer-wrap et .ykm-dots juste après,
   slideChange → compteur/pastilles, clic pastille → slideTo(i). Repli : la méthode scrollLeft de la maquette si Swiper n'apparaît pas
   (activé une fois après 5 s, puis on continue à sonder à 500 ms : le Swiper n'est créé qu'à l'entrée de la galerie dans le viewport).
   Barre collante #ykmBar : logique verbatim de la maquette + prix miroir de #ykTotalPrice (MutationObserver, repli écoute de clic). */
(function(){
 /* yk-port: même seuil que le thème (theme.js : mediaQueryMobile = 'screen and (max-width: 767px)') pour créer le Swiper ; repli si FoxTheme absent */
 if(!matchMedia((window.FoxTheme&&FoxTheme.config&&FoxTheme.config.mediaQueryMobile)||'(max-width:767px)').matches) return;
 function start(){
  var atc=document.getElementById('ykAddBtn');
  var bar=document.getElementById('ykmBar');
  /* yk-port: id réel de la section main lu sur <product-info data-section> (repli : la product-info .section-main-product de la page) */
  var main=(bar&&bar.closest&&bar.closest('product-info[data-section]'))||document.querySelector('product-info.section-main-product[data-section]');
  var sid=main&&main.getAttribute('data-section');
  var gallery=(sid&&document.getElementById('MediaGallery-'+sid))||document.querySelector('.section-main-product media-gallery[id^="MediaGallery-"]');
  var track=gallery&&gallery.querySelector('[id^="Slider-Gallery-"]');
  /* yk-port (Seyvenn 03/09) : la barre est rendue dans la colonne produit (.product__info-container, sticky + transform) → son
     position:fixed était piégé dans ce contexte d'empilement et les sections suivantes passaient par-dessus. On la remonte sous <body>
     comme dans la maquette (où elle était en fin de body). */
  if(bar&&bar.parentNode!==document.body){document.body.appendChild(bar)}

  /* pastilles + compteur sur la galerie */
  if(track&&!track.hasAttribute('data-ykm')){
   track.setAttribute('data-ykm','');
   var items=track.children, n=items.length;
   var wrap=track.closest('.product__media-gallery-viewer-wrap');
   var cnt=document.createElement('span'); cnt.className='ykm-count'; cnt.textContent='1/'+n;
   if(wrap){wrap.style.position='relative'; wrap.appendChild(cnt)}
   var dots=document.createElement('div'); dots.className='ykm-dots';
   for(var k=0;k<n;k++){var d=document.createElement('i'); if(!k)d.setAttribute('data-on','');dots.appendChild(d)}
   if(wrap&&wrap.parentNode) wrap.parentNode.insertBefore(dots,wrap.nextSibling);
   var swiper=null;
   function set(i){
    i=Math.max(0,Math.min(n-1,i));
    cnt.textContent=(i+1)+'/'+n;
    [].forEach.call(dots.children,function(e,j){ j===i ? e.setAttribute('data-on','') : e.removeAttribute('data-on') });
   }
   /* Swiper du thème : compteur/pastilles suivent la diapo active */
   function bind(sw){
    swiper=sw;
    sw.on('slideChange',function(){ set(sw.activeIndex) });
    /* yk-port : media-gallery.js détruit le Swiper au passage desktop et en recrée un au retour mobile → on relâche l'instance et on re-sonde */
    sw.on('destroy',function(){ swiper=null; tries=0; setTimeout(poll,300) });
    set(sw.activeIndex||0);
   }
   /* repli : méthode scrollLeft de la maquette */
   function fallback(){
    var tick=null;
    track.addEventListener('scroll',function(){
     if(tick)return;
     tick=requestAnimationFrame(function(){
      tick=null;
      set(Math.round(track.scrollLeft/track.clientWidth));
     });
    },{passive:true});
   }
   dots.addEventListener('click',function(e){
    var i=[].indexOf.call(dots.children,e.target); if(i<0)return;
    if(swiper) swiper.slideTo(i);
    else if(track.scrollTo) track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});
   });
   /* attente de l'instance Swiper (créée par media-gallery.js après inView) : poll 100 ms jusqu'à 5 s, puis repli (une seule fois)
      et on continue à sonder à 500 ms — la galerie peut entrer dans le viewport plus tard (page restaurée déjà défilée, réseau lent) */
   var tries=0, fb=false;
   function poll(){
    var sw=gallery&&gallery.sliderInstance&&gallery.sliderInstance.slider;
    if(sw&&sw!==swiper&&!sw.destroyed){ bind(sw); return }
    if(++tries<50){ setTimeout(poll,100); return }
    if(!fb){ fb=true; fallback() }
    if(tries<290) setTimeout(poll,500); /* yk-perf: on arrête de sonder après ~2 min */
   }
   poll();
  }

  /* barre collante : apparaît quand le bouton d'origine sort de l'écran */
  if(atc&&bar){
   var last=null;
   function upd(){
    /* affichée dès que le bouton d'origine est passé au-dessus de l'écran */
    var show=atc.getBoundingClientRect().bottom<0;
    if(show===last) return;
    last=show;
    if(show) bar.setAttribute('data-show','');
    else bar.removeAttribute('data-show');
   }
   addEventListener('scroll',upd,{passive:true});
   addEventListener('resize',upd,{passive:true});
   upd();
  }
  var szLabel=document.getElementById('ykmSz');
  document.addEventListener('click',function(e){
   var b=e.target.closest&&e.target.closest('#ykSizes .yk-sz-btn');
   if(b&&szLabel) szLabel.textContent='Taille '+b.textContent.trim();
  },{passive:true});
  var ykmAdd=document.getElementById('ykmAdd');
  if(ykmAdd) ykmAdd.addEventListener('click',function(){
   var sel=document.querySelector('#ykSizes .yk-sz-btn.on');
   if(!sel){ var sz=document.getElementById('ykSizes'); if(sz){var y=sz.getBoundingClientRect().top+scrollY-160; scrollTo({top:y,behavior:'smooth'})} return }
   atc&&atc.click();
  });
  /* prix miroir : <b> de la barre = prix affiché par #ykTotalPrice (valeur initiale rendue par Liquid, spec §4) */
  var total=document.getElementById('ykTotalPrice'), price=bar&&bar.querySelector('.ykm-bar__p b');
  if(total&&price){
   var mirror=function(){ var t=(total.textContent||'').trim(); if(t) price.textContent=t };
   if(window.MutationObserver) new MutationObserver(mirror).observe(total,{childList:true,characterData:true,subtree:true});
   else document.addEventListener('click',function(){ setTimeout(mirror,0) },{passive:true});
   mirror();
  }
 }
 /* defer suffit (DOM analysé), mais on protège le cas où la galerie n'est pas encore dans le DOM */
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
